<template>
    <div class="page-container">
        <SideNav :side-nav-inactive="sideNavInactive">
            <template #search-area>
                <slot name="search-area"></slot>
            </template>
        </SideNav>
        <MainContent>
            <template #action-area>
                <slot name="action-area"></slot>
            </template>
            <slot name="main-content"></slot>
        </MainContent>
    </div>
</template>

<script>
import SideNav from "./SideNav.vue";
import MainContent from "./MainContent.vue";

export default {
    name: "layout",
    components: {MainContent, SideNav},
    props: {
        sideNavInactive: {
            type: Boolean,
            default: false
        }
    },
    created() {
        axios.get('/admin/user/info').then(response => {

        }).catch((errors) => {

        });
    },
    data() {
        return {
            user: this.$store.state.auth.user,
        }
    },
    methods: {},
}
</script>
